import { LoginState } from "@core/models/login.interface";
import { createFeature, createReducer, on } from "@ngrx/store";
import { loginActions } from "./actions";
import { LoginResponse } from "@core/models/api.response";
import { userCredentialsDTO } from "@core/models/dto.models";

export const initialLoginState: LoginState = {
  isLoading: false,
  userCredentials: {} as userCredentialsDTO,
  userData: {} as LoginResponse,
};

const loginFeature = createFeature({
  name: "login",
  reducer: createReducer(
    initialLoginState,
    on(loginActions.requestLogin, (state, event) => ({
      ...state,
      userCredentials: event,
      isLoading: true,
    })),
    on(loginActions.requestLoginSuccess, (state, event) => ({
      ...state,
      userData: event,
      isLoading: false,
    })),
    on(loginActions.requestLoginFailed, (state, event) => ({
      ...state,
      isLoading: false,
    }))
  ),
});

export const { name: loginFeatureKey, reducer: loginReducer } = loginFeature;
